module.exports = __webpack_public_path__ + "media/Animasi-EPOT-Auto-Online-Proctoring.2a9903fc.mp4";